(function () {
  let loading = false;
  let observer = null;

  function nextLink() {
    const wrap = document.querySelector('.pagination-wrapper');
    if (!wrap) return null;
    // Dawn 的 class 命名是反的,"下一页"箭头的 class 是 pagination__item--prev
    return (
      wrap.querySelector('a.pagination__item--prev') ||
      wrap.querySelector('li:last-child a.pagination__item-arrow')
    );
  }

  function showLoader() {
    const loader = document.querySelector('#InfiniteScrollLoader');
    if (loader) loader.classList.remove('hidden');
  }

  function hideLoader() {
    const loader = document.querySelector('#InfiniteScrollLoader');
    if (loader) loader.classList.add('hidden');
  }

  function setup() {
    const wrapper = document.querySelector('.pagination-wrapper');
    if (!wrapper || !nextLink()) {
      hideLoader();
      return;
    }
    if (observer) observer.disconnect();

    observer = new IntersectionObserver(async (entries) => {
      if (!entries[0].isIntersecting || loading) return;
      const link = nextLink();
      if (!link) {
        observer.disconnect();
        hideLoader();
        return;
      }

      loading = true;
      showLoader();
      try {
        const res = await fetch(link.href);
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');

        const grid = document.querySelector('#product-grid');
        const newItems = doc.querySelectorAll('#product-grid > li');
        if (grid) newItems.forEach((li) => grid.appendChild(li));

        const oldWrap = document.querySelector('.pagination-wrapper');
        const newWrap = doc.querySelector('.pagination-wrapper');
        if (oldWrap && newWrap) {
          oldWrap.replaceWith(newWrap);
          observer.disconnect();
          observer.observe(newWrap);
        } else if (oldWrap) {
          oldWrap.remove();
          observer.disconnect();
        }
      } catch (e) {
        console.error('[infinite-scroll]', e);
      } finally {
        loading = false;
        hideLoader();
      }
    }, { rootMargin: '600px' });

    observer.observe(wrapper);
  }

  document.addEventListener('DOMContentLoaded', () => {
    setup();
    // 筛选/排序后 Dawn 会重建整个网格,需要重新绑定
    const container = document.querySelector('#ProductGridContainer');
    if (container) {
      new MutationObserver(() => {
        clearTimeout(window.__isRebind);
        window.__isRebind = setTimeout(setup, 150);
      }).observe(container, { childList: true });
    }
  });
})();
